import { render, staticRenderFns } from "./FormatosFree.vue?vue&type=template&id=0adf2b6e&scoped=true&"
import script from "./FormatosFree.vue?vue&type=script&lang=js&"
export * from "./FormatosFree.vue?vue&type=script&lang=js&"
import style0 from "./FormatosFree.vue?vue&type=style&index=0&id=0adf2b6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf2b6e",
  null
  
)

export default component.exports